// Lista e detalhe de viagens do viajante.

export const pt = {
  listTitle: 'Minhas viagens',
  backToTrips: 'Viagens',
  days: '{n} dia',
  daysPlural: '{n} dias',
  custeioLabel: 'custeio',
  pendingSync: 'pendente de sincronização',
  refresh: 'Atualizar',
  notFound: 'Viagem não encontrada no cache local. Conecte-se pra baixar os dados.',
  actionError: 'Não foi possível concluir a ação',
  cannotAddExpense: 'Não é possível lançar gastos neste momento.',
  finalizar: 'Finalizar viagem',
  prestarContas: 'Prestar contas',
  addExpense: '+ Lançar gasto',
  expensesTitle: 'Gastos',
  kmRodado: 'Km rodado: {km} km',
  odometro: {
    title: 'Odômetro de chegada',
    subtitle: 'Informe a quilometragem do veículo na chegada para fechar o km rodado.',
    label: 'Odômetro de chegada (km)',
    invalid: 'Informe um número inteiro válido (ex.: 84500)',
    tooLow: 'Deve ser maior ou igual ao odômetro de saída ({min} km)',
  },
  empty: {
    title: 'Nenhuma viagem por aqui',
    description: 'Suas viagens aprovadas aparecem aqui assim que forem cadastradas.',
  },
  stats: {
    teto: 'Teto',
    gasto: 'Gasto',
    sobra: 'Sobra',
  },
  card: {
    spent: 'gasto {v}',
    cap: 'teto {v}',
  },
  statusHint: {
    rascunho: 'Viagem ainda não foi submetida para aprovação.',
    aguardando_aprovacao: 'Aguardando aprovação do gestor pra liberar o teto na caja chica.',
    finalizada: 'Viagem finalizada — falta prestar contas.',
    em_prestacao: 'Em prestação de contas — aguardando aprovação do gestor.',
    encerrada: 'Viagem encerrada.',
    rejeitada: 'Viagem rejeitada.',
  },
};

export const es: typeof pt = {
  listTitle: 'Mis viajes',
  backToTrips: 'Viajes',
  days: '{n} día',
  daysPlural: '{n} días',
  custeioLabel: 'financiación',
  pendingSync: 'pendiente de sincronización',
  refresh: 'Actualizar',
  notFound: 'Viaje no encontrado en la caché local. Conéctese para descargar los datos.',
  actionError: 'No se pudo completar la acción',
  cannotAddExpense: 'No es posible registrar gastos en este momento.',
  finalizar: 'Finalizar viaje',
  prestarContas: 'Rendir cuentas',
  addExpense: '+ Registrar gasto',
  expensesTitle: 'Gastos',
  kmRodado: 'Km recorridos: {km} km',
  odometro: {
    title: 'Odómetro de llegada',
    subtitle: 'Ingrese el kilometraje del vehículo a la llegada para cerrar los km recorridos.',
    label: 'Odómetro de llegada (km)',
    invalid: 'Ingrese un número entero válido (ej.: 84500)',
    tooLow: 'Debe ser mayor o igual al odómetro de salida ({min} km)',
  },
  empty: {
    title: 'Ningún viaje por aquí',
    description: 'Sus viajes aprobados aparecen aquí en cuanto sean registrados.',
  },
  stats: {
    teto: 'Tope',
    gasto: 'Gastado',
    sobra: 'Saldo',
  },
  card: {
    spent: 'gastado {v}',
    cap: 'tope {v}',
  },
  statusHint: {
    rascunho: 'El viaje aún no fue enviado para aprobación.',
    aguardando_aprovacao: 'Esperando aprobación del gestor para liberar el tope en la caja chica.',
    finalizada: 'Viaje finalizado — falta rendir cuentas.',
    em_prestacao: 'En rendición de cuentas — esperando aprobación del gestor.',
    encerrada: 'Viaje cerrado.',
    rejeitada: 'Viaje rechazado.',
  },
};
